<template>
  <el-dialog top="10vh" :title="title" append-to-body class="zhanwei-dialog" :before-close="close" :close-on-click-modal="false" :visible.sync="dialogVisible">
    <!-- <el-carousel v-if="url.length > 1" trigger="click" height="55vh">
      <el-carousel-item v-for="item in url" :key="item">
        <img :src="item" alt="" />
      </el-carousel-item>
    </el-carousel> -->
    <el-image :src="showUrl" alt="">
      <div class="load-box" slot="placeholder" v-loading="true"></div>
    </el-image>
    <el-button class="left-icon" v-if="index > 0 && url.length > 1" circle icon="el-icon-arrow-left" @click="add(-1)" />
    <el-button class="right-icon" v-if="index < url.length - 1 && url.length > 1" circle icon="el-icon-arrow-right" @click="add(1)" />
    <!-- <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">关闭</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: String,
    url: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      showUrl: this.url[0],
      index: 0,
    }
  },
  mounted() {},
  methods: {
    add(num) {
      this.index = this.index + num
      this.showUrl = this.url[this.index]
    },
    close() {
      this.$emit('update:visible', false)
    },
  },
}
</script>
<style lang="less">
.zhanwei-dialog {
  .el-dialog__body {
    padding: 10px;
  }
  .left-icon {
    position: absolute;
    top: 50%;
    left: 10px;
  }
  .right-icon {
    position: absolute;
    top: 50%;
    right: 10px;
  }
  .el-image {
    min-height: 200px;
    width: 100%;
    .load-box {
      width: 100%;
      height: 100%;
    }
  }
  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
